

























import { Component, Vue, Prop } from "vue-property-decorator";
import { serverBase } from "../apollo";

@Component
export default class DVDRenderer extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop() movie!: string;

  light = "false";

  toggleMode() {
    if (this.light == "false") this.light = "true";
    else this.light = "false";
  }

  get url() {
    return serverBase + `/dvd-renderer/${this.movie}?light=${this.light}`;
  }
}
